/* eslint-disable import/no-cycle */
import { IAmazonCompositeKeywordData, IAmazonStatistic } from '../../../constants/research';
import { KEYWORD_PRODUCT_COUNT } from '../keyword-evaluation.config';


export class ProductsEvaluatorService {


	/**------------------------------------------------------
	 * Product Evaluations
	 */
	productDistribution(keywordData: IAmazonCompositeKeywordData): IProductDistributionEvaluation {

		//0 - how many total products are there?
		const totalProducts: number = keywordData.amazon.competition.asinLists.general.length
			+ keywordData.amazon.competition.asinLists.clothing.length
			+ keywordData.amazon.competition.asinLists.book.length;

		//1 - calculate the distributions
		return {
			general		: Math.round(keywordData.amazon.competition.asinLists.general.length 	/ totalProducts),
			clothing	: Math.round(keywordData.amazon.competition.asinLists.clothing.length 	/ totalProducts),
			book		: Math.round(keywordData.amazon.competition.asinLists.book.length 		/ totalProducts)
		};
	}

	sponsored(keywordData: IAmazonCompositeKeywordData): number {
		return keywordData.amazon.competition.asinLists.sponsored.length;
	}

	competingProducts(keywordData: IAmazonCompositeKeywordData): number {
		return keywordData.amazon.competition.totalProducts;
	}

	topAsinRanks(keywordData: IAmazonCompositeKeywordData): string[] {
		return [
			...keywordData.amazon.competition.asinLists.general,
			...keywordData.amazon.competition.asinLists.clothing,
			...keywordData.amazon.competition.asinLists.book
		];
	}

	productPricing(keywordData: IAmazonCompositeKeywordData): IProductPricingEvaluation {
		return {
			page1: keywordData.amazon.competition.price.page1,
			avg	 : keywordData.amazon.competition.price.avg,
			min	 : keywordData.amazon.competition.price.min,
			max	 : keywordData.amazon.competition.price.max
		};
	}

	productReviews(keywordData: IAmazonCompositeKeywordData): IProductReviewsEvaluation {
		return {
			stars	: keywordData.amazon.competition.reviews.stars,
			reviews	: keywordData.amazon.competition.reviews.count
		};
	}

	reviewPage1(keywordData: IAmazonCompositeKeywordData): number {
		return Math.round(keywordData.amazon.competition.reviews.count.page1) * KEYWORD_PRODUCT_COUNT.PAGE_1;
	}

	brands(keywordData: IAmazonCompositeKeywordData): string[] {
		return keywordData.amazon.competition.brands;
	}

	numberOfBrands(keywordData: IAmazonCompositeKeywordData): number {
		return keywordData.amazon.competition.brands.length;
	}

	categories(keywordData: IAmazonCompositeKeywordData): string[] {
		return keywordData.amazon.competition.categories;
	}

	numberOfCategories(keywordData: IAmazonCompositeKeywordData): number {
		return keywordData.amazon.competition.categories.length;
	}
}


//** Interfaces --------------------------------- */
export interface IProductDistributionEvaluation {
	general		: number;
	clothing	: number;
	book		: number;
}

export interface IProductPricingEvaluation {
	page1		: number;
	avg			: number;
	min			: number;
	max			: number;
}

export interface IProductReviewsEvaluation {
	stars		: IAmazonStatistic;
	reviews		: IAmazonStatistic;
}
